<template>
  <div>
    <van-tabs v-model="active" @click="rel()">
      <van-tab title="首页" name="indexs">
      </van-tab>
      <van-tab title="分账订单" name="index1">
      </van-tab>
      <van-tab title="分账信息" name="index2">
      </van-tab>
    </van-tabs>
    <div class='index2'>
      <div v-if="sure" class="fl1 loads">
        <div class="xql">
          <van-loading size="26px" color="#fff" type="spinner" vertical>加载中...</van-loading>
        </div>
      </div>
      <div style="display: flex;align-items: center;">
        <van-cell title="选择日期" :value="date" @click="show = true" />
        <van-calendar v-model="show" :show-confirm="false" :min-date="minDate" :max-date="maxDate" type="range" @confirm="onConfirm" :allow-same-day="true" />
        <van-button type="primary" color="#1260FC" style="flex-shrink: 0;margin-left: 1rem;" @click="downOrder">导出</van-button>
      </div>
      <van-list :finished="finished" finished-text="没有数据了" v-model="loading" @load="onLoad" offset="120" :immediate-check='nos' v-if="list.length != 0">
        <div class="gain_mx_con" v-for="(v, k) in list" :key="k">
          <div style="margin: .8rem 0;">订单编号：{{ v.order_no }}</div>
          <!-- <div class="line"></div> -->
          <div class="gain_mx_box">
            <div>订单金额：<span style="color: #67c23a;">{{ v.order_money }}元</span></div>
            <div class="w45">订单类型：{{ v.type_str }}</div>
          </div>
          <div class="gain_mx_box">
            <div>交易手续费：{{ v.fee }}元</div>
            <div class="w45">分账金额：<span style="color: #67c23a;">{{ v.amount }}元</span></div>
          </div>
          <div class="gain_mx_box">分账时间：{{ v.ctime }}</div>
          <div class="gain_mx_box" style="color: #1206ef;">{{ v.district_name }}</div>
        </div>
      </van-list>
      <img src="../../assets/ww.png" style="width: 100%;" v-else>
      <div style="height: 6rem;"></div>
      <scrollTop v-if="list.length != 0"></scrollTop>
    </div>
    <van-popup v-model:show="showDown" position="bottom" :style="{ height: '50%' }">
      <div style="padding: 1rem;height: auto;">
        <div style="text-align: right;margin-bottom: 1rem;" @click="showDown = false">
          关闭
        </div>
        <van-tabs v-model:active="downActive">
          <van-tab :title="el.name" v-for="(el,index) in downList" :key="index">
            <div style="width: 100%;word-break: break-word;font-size: 1.4rem;padding: 1rem;box-sizing: border-box;border: 1px solid #999;margin-top: .5rem;">
              {{el.url}}
            </div>
          </van-tab>
        </van-tabs>
        <div style="font-size: 1.5rem;margin-top: .5rem;">
          <p class="qx_p">操作方式:</p>
          <p class="qx_p">第一步.请复制链接;</p>
          <p class="qx_p">第二步.复制链接PC端浏览器内即可下载，或复制在手机浏览器中，点击“分享”，发送至邮箱;</p>
        </div>
        <div style="display: flex;align-items: center;justify-content: center;margin-top: .5rem;">
          <van-button type="primary" color="#1260FC" @click="copyLink">复制链接</van-button>
        </div>
      </div>
    </van-popup>

  </div>
</template>

<script>
  import { Toast } from 'vant'
  import scrollTop from "@/components/scroll.vue"
  import { getAccOrder, downAccOrder } from "@/api"
  export default {
    components: { scrollTop },
    data() {
      return {
        active: 'index1',
        downActive: 0,
        showDown: false,
        date: '',
        date1: '',
        date2: '',
        sure: true,
        // 列表触底
        loading: false,
        nos: false,
        finished: false,
        refreshing: false,
        page: 1,
        list: [],
        downList: [],
        show: false,
        minDate: this.$store.state.mindate,
        maxDate: new Date(),
      };
    },
    methods: {
      rel() {
        this.$router.push({ path: this.active });
      },
      // 触底
      onLoad() {
        this.page++;
        this.get();
      },
      copyLink() {
        let url = this.downList[this.downActive].url;
        this.copyTextToClipboard(url)
      },
      async copyTextToClipboard(text) {
        try {
          await navigator.clipboard.writeText(text);
          Toast.success('链接已复制，请在浏览器中打开');
          return true;
        } catch (err) {
          Toast.error('复制失败');
          return false;
        }
      },
      async downOrder() {
        let data = await downAccOrder({
          member_id: localStorage.getItem("MemberId"),
          mch_id: localStorage.getItem("MchId"),
          vender_id: localStorage.getItem("VenderId"),
          page: this.page,
          startdate: this.date1,
          enddate: this.date2
        })
        this.downList = data.data ? data.data : [];
        this.showDown = true
      },
      // 获取数据
      async get() {
        let data = await getAccOrder({
          member_id: localStorage.getItem("MemberId"),
          mch_id: localStorage.getItem("MchId"),
          vender_id: localStorage.getItem("VenderId"),
          page: this.page,
          startdate: this.date1,
          enddate: this.date2
        });
        if (data.code == 1) {
          this.list = this.list.concat(data.data);
          this.loading = false;
          if (data.data.length < 2) {
            this.finished = true;
          }
        }
        this.sure = false;
      },
      formatDate(date) {
        return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
      },
      onConfirm(date) {
        const [start, end] = date;
        console.log(date);
        this.show = false;
        this.date1 = this.formatDate(start);
        this.date2 = this.formatDate(end);
        this.date = `${this.formatDate(start)} / ${this.formatDate(end)}`;
        this.page = 1;
        this.news1();
      },
      // 搜索
      async news1() {
        this.page = 1;
        this.finished = false;
        this.sure = true;
        this.list = [];
        let data = await getAccOrder({
          member_id: localStorage.getItem("MemberId"),
          mch_id: localStorage.getItem("MchId"),
          vender_id: localStorage.getItem("VenderId"),
          page: this.page,
          startdate: this.date1,
          enddate: this.date2
        });
        if (data.code == 1) {
          this.list = this.list.concat(data.data);
          this.loading = false;
          if (data.data.length < 2) {
            this.finished = true;
          }
        }
        this.sure = false;
      }
    },
    mounted() {
      this.date1 = this.formatDate(new Date(new Date() - 30 * 24 * 60 * 60 * 1000));
      this.date2 = this.formatDate(new Date());
      this.date = `${this.date1} / ${this.date2}`;
      this.get();
    }
  }
</script>
<style lang='less'>
  .index2 {
    padding: 1rem 1rem 0;

    .van-cell {
      padding: 10px 30px 10px 16px;
    }

    .oper_nav {
      width: 10%;
      height: 4rem;
      display: flex;
      justify-content: center;
      align-items: center;

      .oper_img1 {
        margin-top: .6rem;
        width: 4rem;
        height: 4rem;
      }
    }

    .van-cell {
      border-radius: 1rem;
    }

    .gain_mx_con {
      padding: .6rem 1.6rem .6rem;
      background-color: #fff;
      border-radius: .6rem;
      margin: .8rem 0;
    }

    .van-calendar__day--middle {
      color: #1260FC;
    }

    .van-cell__title {
      color: #1260FC !important;
    }

    .van-calendar__day--end,
    .van-calendar__day--multiple-middle,
    .van-calendar__day--multiple-selected,
    .van-calendar__day--start,
    .van-calendar__day--start-end {
      background-color: #1260FC;
      border-radius: .6rem;
    }

    .van-cell__title {
      -webkit-box-flex: 0.8;
      -webkit-flex: 0.8;
      flex: 0.8;
    }

    .van-cell__value {
      -webkit-box-flex: 1;
      -webkit-flex: 1;
      flex: 1;
      white-space: nowrap;
    }

    .line {
      width: 35rem;
      height: 1px;
      background-color: #F6F7F0;
    }

    .gain_mx_box {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 1rem 0;
      font-size: 1.5rem;
    }

    .w45 {
      width: 45%;
    }

    .gain_t {
      display: flex;
      align-items: center;
      font-size: 1.6rem;
      color: #333;

      img {
        width: 2rem;
      }
    }
  }
</style>